var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shopReviewScore" }, [
    _c("div", { staticClass: "shopReviewScore__item" }, [
      _c("div", { staticClass: "shopReviewScore__title" }, [
        _vm._v("満足度平均"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shopReviewGraph" },
        [
          _c("donut-chart", { attrs: { rating: _vm.totalAverageRating } }),
          _vm._v(" "),
          _c("slider-chart", { attrs: { "rating-counts": _vm.ratingCounts } }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopReviewScore__item" }, [
      _c("div", { staticClass: "shopReviewScore__title" }, [
        _vm._v("各項目の評価"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shopReviewRating" },
        _vm._l(_vm.ratingLabels, function (label, rating) {
          return _c(
            "div",
            { key: rating, staticClass: "shopReviewRating__item" },
            [
              _c("div", { staticClass: "shopReviewRating__label" }, [
                _vm._v(_vm._s(label)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "shopReviewRating__rating" }, [
                _vm._v(
                  _vm._s(
                    _vm.ratingAverages[rating]
                      ? _vm.ratingAverages[rating].toFixed(1)
                      : "-"
                  )
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }